<template>
  <c-container fluid class="d-flex content-center min-vh-100 login-container c-app c-dark-theme">
    <img class="logo" src="/img/logos/longboss.png" alt="KoalaBoss logo" />
    <c-row>
      <c-col>
        <c-card-group>
          <c-card class="p-4 login-form">
            <c-card-body>
              <c-alert show v-if="error" color="warning" close-button class="mt-4">
                {{ error }}
              </c-alert>
              <template v-if="isChangingUsername" />
              <template v-else>
                <h2 class="mb-3">Email address updated!</h2>
                <p class="lead">
                  <strong>{{ newUsername }}</strong>
                </p>
                <p v-if="!$auth.check()" class="lead">
                  Please
                  <router-link to="/login">login</router-link>
                  using your new email address.
                </p>
                <p v-else class="lead">
                  Go to
                  <router-link to="/">home page</router-link>
                  .
                </p>
              </template>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'UsernameChangeConfirm',
  data() {
    return {
      error: null,
      isChangingUsername: true,
      changeSuccess: false,
      newUsername: '',
    };
  },
  mounted() {
    this.doUsernameChange();
  },
  methods: {
    doUsernameChange() {
      this.error = null;
      this.$http
        .get(buildEndpoint('account/username-change/') + this.$route.params.newUsernameRequestKey)
        .then((response) => {
          this.isChangingUsername = false;
          if (response.data.success) {
            this.changeSuccess = true;
            this.newUsername = response.data.data.newUsername;
          } else {
            this.error = response.data.message;
          }
        })
        .catch((error) => {
          this.error = error;
        });
    },
  },
};
</script>
